<template>
    <div class="animated fadeIn">
      <Loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></Loading>
      <b-row>
        <b-col md="12">
          <b-card>
            <div slot="header">
              <b-col sm="12" lg="8" class="pt-2 p-1 title">
                <span>Relatório de transações de compras BirdID</span>
              </b-col>
            </div>
            <b-form @submit.stop.prevent>
              <div style="text-align: center;">Intervalo máximo 3 meses</div>
              <b-form-group label="Início" label-for="txt-datetime-inicio">
                <b-form-input type="datetime-local" id="txt-datetime-inicio" v-model="filters.initDateTime" class="mb-1 mr-sm-1 mb-sm-0"></b-form-input>
              </b-form-group>
  
              <b-form-group label="Fim" label-for="txt-datetime-fim">
                <b-form-input type="datetime-local" id="txt-datetime-fim" v-model="filters.endDateTime" class="mb-1 mr-sm-1 mb-sm-0"></b-form-input>
              </b-form-group>
  
              <div slot="footer">
                <b-row>
                  <b-col sm="6" lg="2">
                    <b-button variant="primary" class="form-control" @click="visualize">Visualizar</b-button>
                  </b-col>
                  <b-col sm="6" lg="2">
                    <b-button variant="secondary" class="form-control" @click="download">Download</b-button>
                  </b-col>
                </b-row>
              </div>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
      <template v-if="chart01.show">
        <b-row >
          <b-col md="12">
            <b-card>
              <b-row>
                <b-col md="12">
                  <h4 class="card-title">Quantidade de vendas por dia</h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <Chart chart-id="purchase-transactions-qtd-vendas-dia" :chart-data="chart01.data"></Chart>
                </b-col>
              </b-row>
              <div slot="footer">
                <b-row class="text-center">
                  <b-col class="mb-sm-2 mb-0">
                    <strong>{{ chart01.total.apple }}</strong>
                    <b-progress height={} class="progress-xs mt-2" :precision="1" variant="assinaturas" :value="50"></b-progress>
                  </b-col>
                  <b-col class="mb-sm-2 mb-0">
                    <strong>{{ chart01.total.google }}</strong>
                    <b-progress height={} class="progress-xs mt-2" :precision="1" variant="autenticacoes" :value="50"></b-progress>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row >
          <b-col md="12">
            <b-card>
              <b-row>
                <b-col md="12">
                  <h4 class="card-title">Total de vendas por dia (BRL)</h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <Chart :yAxesCurrencyBrl="true" chart-id="purchase-transactions-total-vendas-dia" :chart-data="chart02.data"></Chart>
                </b-col>
              </b-row>
              <div slot="footer">
                <b-row class="text-center">
                  <b-col class="mb-sm-2 mb-0">
                    <strong>{{ chart02.total.apple }}</strong>
                    <b-progress height={} class="progress-xs mt-2" :precision="1" variant="assinaturas" :value="50"></b-progress>
                  </b-col>
                  <b-col class="mb-sm-2 mb-0">
                    <strong>{{ chart02.total.google }}</strong>
                    <b-progress height={} class="progress-xs mt-2" :precision="1" variant="autenticacoes" :value="50"></b-progress>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-card>
              <b-row>
                <b-col md="12">
                  <b-table class="purchase-transactions-table" :hover="false" :striped="false" :bordered="false" :small="false" :fixed="false" responsive="sm"
                    :items="table01.items" :fields="table01.fields" :per-page="table01.perPage" :current-page="table01.currentPage">
                  </b-table>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-card>
              <b-row>
                <b-col md="12">
                  <h4 class="card-title">Quantidade de vendas por plano</h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-table class="purchase-count-table" :hover="false" :striped="false" :bordered="false" :small="false" :fixed="false" responsive="sm"
                    :items="table02.items" :fields="table02.fields" :per-page="table02.perPage" :current-page="table02.currentPage">
                  </b-table>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </template>
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import { requestError, env } from '@/shared/utils'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import Chart from '@/views/reports/PurchaseTransactions/Chart.vue'
  
  export default {
    name: 'report_purchase_transactions',
    components: {
      Loading,
      Chart,
    },
    data: function() {
      return {
        filters: {},
        isLoading: false,
        chart01: {
            show: false,
            total: {
              google: '0 Qtd. vendas Google',
              apple: '0 Qtd. vendas Apple'
            },
            data: {
              labels: [],
              google: [],
              apple: []
            },
        },
        chart02: {
            total: {
              google: 'R$ 0,00 Total vendas Google',
              apple: 'R$ 0,00 Total vendas Apple'
            },
            data: {
              labels: [],
              google: [],
              apple: []
            },
        },
        table01: {
            items: [],
            fields: [],
            perPage: 99,
            currentPage: 1,
        },
        table02: {
            items: [],
            fields: [],
            perPage: 99,
            currentPage: 1,
        },
      }
    },
    methods: {
      validate() {
        if (!this.filters.initDateTime || !this.filters.endDateTime) {
          alert("O período deve ser informado!");
          return false;
        }
        let diffDays = (new Date(this.filters.endDateTime) - new Date(this.filters.initDateTime)) / 1000 / 60 / 60 / 24;
        let limit = 90;
        if (diffDays > limit) {
          alert(`O período não deve exceder a ${limit} dias.`);
          return false;
        }
        return true;
      },
      async download () {
        if (!this.validate()) {
          return;
        }
        this.isLoading = true;
        await axios
          .get(`${env.urlBillingApi}/purchase-transactions?initDateTime=${this.filters.initDateTime}&endDateTime=${this.filters.endDateTime}`,
            { headers: { 'Accept': 'text/csv' } })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            const fileName = `purchase_transactions_${this.filters.initDateTime}_${this.filters.endDateTime}.csv`;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
          })
          .catch(function(error) {
            requestError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
      async visualize () {
        if (!this.validate()) {
          return;
        }
        this.isLoading = true;
        this.chart01.show = false;
        await axios.get(
          `${env.urlBillingApi}/purchase-transactions?initDateTime=${this.filters.initDateTime}&endDateTime=${this.filters.endDateTime}`,
          { headers: { 'Accept': 'application/json' }})
          .then((response) => {
            const respfilters = response.data.filters;
            const respGoogle = response.data.google;
            const respApple = response.data.apple;
            this.createPlanTable(respGoogle, respApple);
            const _startDate = new Date(respfilters.startDate);
            const _endDate = new Date(respfilters.endDate);
            const labels = [];
            for (let d = _startDate; d <= _endDate; d.setDate(d.getDate() + 1)) {
              labels.push(d.toISOString().split('T')[0]);
            }
            const googleQtd = [];
            const appleQtd = [];
            const googleValues = [];
            const appleValues = [];
            respGoogle.forEach((item) => {
              const _data = new Date(item[7]);
              const _index = labels.indexOf(_data.toISOString().split('T')[0]);
              if (_index >= 0){
                googleQtd[_index] = googleQtd[_index] ? googleQtd[_index] + 1 : 1;
                if (item[10] === 'BRL'){
                  googleValues[_index] = googleValues[_index] ? googleValues[_index] + item[9] : item[9];
                }
              }
            });
            respApple.forEach((item) => {
              const _data = new Date(item[7]);
              const _index = labels.indexOf(_data.toISOString().split('T')[0]);
              if (_index >= 0){
                appleQtd[_index] = appleQtd[_index] ? appleQtd[_index] + 1 : 1;
                if (item[10] === 'BRL'){
                  appleValues[_index] = appleValues[_index] ? appleValues[_index] + item[9] : item[9];
                }
              }
            });
            labels.forEach((item, index) => {
              if (!googleQtd[index]) googleQtd[index] = 0;
              if (!appleQtd[index]) appleQtd[index] = 0;
              googleValues[index] = googleValues[index] ? parseFloat(googleValues[index].toFixed(2)) : 0;
              appleValues[index] = appleValues[index] ? parseFloat(appleValues[index].toFixed(2)) : 0;
              labels[index] = item.split('-')[2] + '/' + item.split('-')[1];
            });
            this.chart01.total.google = `${respGoogle.length} Qtd. vendas Google`;
            this.chart01.total.apple = `${respApple.length} Qtd. vendas Apple`;
            this.chart01.data = {
              labels,
              google: googleQtd,
              apple: appleQtd,
            };
            this.chart02.total.google = `R$ ${_.sum(googleValues).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')} Total vendas Google`;
            this.chart02.total.apple = `R$ ${_.sum(appleValues).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')} Total vendas Apple`;
            this.chart02.data = {
              labels,
              google: googleValues,
              apple: appleValues,
            };
            const fields = [ { key: 'platform', label: 'Plataforma' } ];
            const typesOfCoins = _.uniq([...respGoogle.map((item) => item[10]), ...respApple.map((item) => item[10])]);
            typesOfCoins.forEach((coin) => { fields.push({ key: coin, label: coin }) });
            fields.push({ key: 'total', label: 'Total Geral' });
            const groupByGoogleByCoin = _.groupBy(respGoogle, (item) => item[10]);
            const totalGoogleByCoin = typesOfCoins.map((key) => {
              if (!Array.isArray(groupByGoogleByCoin[key])) return { key: key, value: 0 };
              const total = _.sum(groupByGoogleByCoin[key].map((item) => item[9]));
              return { key: key, value: total };
            });
            const groupByAppleByCoin = _.groupBy(respApple, (item) => item[10]);
            const totalAppleByCoin = typesOfCoins.map((key) => {
              if (!Array.isArray(groupByAppleByCoin[key])) return { key: key, value: 0 };
              const total = _.sum(groupByAppleByCoin[key].map((item) => item[9]));
              return { key: key, value: total };
            });
            const items = [
              Object.assign({ platform: 'Apple' }, Object.fromEntries(totalAppleByCoin.map((item) => [item.key, item.value.toFixed(2)])), { total: _.sum(totalAppleByCoin.map((item) => item.value)).toFixed(2) }),
              Object.assign({ platform: 'Google' }, Object.fromEntries(totalGoogleByCoin.map((item) => [item.key, item.value.toFixed(2)])), { total: _.sum(totalGoogleByCoin.map((item) => item.value)).toFixed(2) }),
              Object.assign({ platform: 'Total Geral' }, Object.fromEntries(typesOfCoins.map((key) => [key, (totalGoogleByCoin.find((item) => item.key === key).value + totalAppleByCoin.find((item) => item.key === key).value).toFixed(2)])), { total: (_.sum(totalGoogleByCoin.map((item) => item.value)) + _.sum(totalAppleByCoin.map((item) => item.value))).toFixed(2) }),
            ];
            this.table01 = {
              items,
              fields,
              perPage: 99,
              currentPage: 1,
            };
            this.chart01.show = true;
          })
          .catch(function(error) {
            requestError(error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      },

      createPlanTable(respGoogle, respApple) {
        const fields = [ { key: 'platform', label: 'Plataforma' } ];
        const items = [];
        let itemsByPlan = {};
        let itemsByPlanTotal = {};
        let totalGoogle = 0;
        respGoogle.forEach((itm) => {
          if (!fields.some(itm => itm.key == itm[6])) {
            fields.push({key: itm[6], label: itm[6]})
          }
          if (!itemsByPlanTotal[itm[6]]) {
            itemsByPlanTotal[itm[6]] = 0
          }
          itemsByPlanTotal[itm[6]] += 1
          if (!itemsByPlan[itm[6]]) {
            itemsByPlan[itm[6]] = 0
          }
          itemsByPlan[itm[6]] += 1
          totalGoogle++;
        })
        items.push({ platform: 'Google', ...itemsByPlan, total: totalGoogle })

        itemsByPlan = {};
        let totalApple = 0;
        respApple.forEach((itm) => {
          if (!fields.some(itm => itm.key == itm[6])) {
            fields.push({key: itm[6], label: itm[6]})
          }
          if (!itemsByPlanTotal[itm[6]]) {
            itemsByPlanTotal[itm[6]] = 0
          }
          itemsByPlanTotal[itm[6]] += 1
          if (!itemsByPlan[itm[6]]) {
            itemsByPlan[itm[6]] = 0
          }
          itemsByPlan[itm[6]] += 1
          totalApple++;
        })
        fields.push({ key: 'total', label: 'Total Geral' });
        items.push({ platform: 'Apple', ...itemsByPlan, total: totalApple })
        items.push({ platform: 'Total Geral', ...itemsByPlanTotal, total: (totalApple + totalGoogle) })
        this.table02 = {
          items,
          fields,
          perPage: 99,
          currentPage: 1,
        };
      }
    }
  }
  </script>
<style scoped>
  .title {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>
<style>
  .purchase-transactions-table > table > thead > tr > th {
    border-top: none;
  }
  .purchase-transactions-table > table > tbody > tr:last-child {
    border-top: 2px solid #c8ced3;
    font-weight: bold;
  }
</style>